module.exports = __webpack_public_path__ + "img/NEW CLUBMASTER.2dd9b2af.jpg";